// extracted by mini-css-extract-plugin
var _1 = "MAxg9SkCZlF94AiJXnZQ";
var _2 = "MAxg9SkCZlF94AiJXnZQ";
var _3 = "djiGCF7gaCZnYkxEM8XR";
export { _1 as "form-bottom-margin", _2 as "formBottomMargin", _3 as "title" }
